import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { startCase, camelCase } from 'lodash-es';
import { Subscription } from 'rxjs';
import { getBrandConfig } from '../services/branding';

export const SetPageTitle = (router: Router, titleService: Title) => (): Subscription => {
  // Use the active brand's display name (e.g. "Salt Treasury Operations") instead of
  // a hardcoded "RocketKOR Admin Portal", otherwise every navigation overrides the
  // brand title that main.ts set on load.
  const appTitle = getBrandConfig().displayName;

  return router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe({
    next: (path) => {
      const routePath = path.url.split('/');
      let route = routePath.pop()?.split('?')[0] || '';

      if (/\d/.test(route)) {
        route = routePath[routePath.length - 1];
      }

      titleService.setTitle(route ? `${appTitle} - ${startCase(camelCase(route))}` : appTitle);
    },
  });
};
